import { useEffect, useState } from 'react';
import { api, type HuntListing } from '../api';
import { getTheme, useThemeMode } from '../theme';

/** Admin: alla aktiva gamla jaktannonser (hunt_listings). Avpublicera (status cancelled, finns kvar) eller ta bort permanent. D5: de visas inte publikt längre. */
export function AdminListingsSection() {
  const T = getTheme(useThemeMode().mode);
  const [listings, setListings] = useState<HuntListing[] | null>(null);
  const [busyId, setBusyId] = useState<string | null>(null);
  const [err, setErr] = useState('');

  useEffect(() => { api.huntListings().then(setListings).catch(e => { setErr(e.message || String(e)); setListings([]); }); }, []);

  async function run(id: string, action: () => Promise<unknown>) {
    setBusyId(id); setErr('');
    try { await action(); setListings(prev => prev?.filter(l => l.id !== id) ?? null); }
    catch (e: any) { setErr(e.message || String(e)); }
    finally { setBusyId(null); }
  }
  const unpublish = (l: HuntListing) => run(l.id, () => api.updateHuntListing(l.id, { status: 'cancelled' }));
  const remove = (l: HuntListing) => { if (confirm(`Ta bort annonsen "${l.title}" permanent?`)) void run(l.id, () => api.deleteHuntListing(l.id)); };

  const btn = (color: string) => ({ padding: '6px 10px', borderRadius: 5, border: `1px solid ${color}`, background: 'transparent', color, fontSize: 12, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit', flexShrink: 0 });
  return (
    <div>
      <p style={{ fontSize: 13, color: T.textSub, margin: '0 0 12px', lineHeight: 1.5 }}>Gamla jaktannonser (före markannonserna). De visas inte längre publikt och tar inte emot bokningar – nya jakter läggs som annonser på marken. Avpublicera döljer annonsen men behåller den; ta bort raderar den.</p>
      {err && <div style={{ color: '#f87171', fontSize: 13, marginBottom: 12 }}>{err}</div>}
      {!listings && <div style={{ color: T.textMuted, fontSize: 13 }}>Laddar…</div>}
      {listings?.length === 0 && !err && <div style={{ color: T.textMuted, fontSize: 13 }}>Inga annonser.</div>}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {listings?.map(l => (
          <div key={l.id} style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', padding: '10px 12px', background: T.surface, borderRadius: 6, border: `1px solid ${T.border}` }}>
            <div style={{ flex: '1 1 180px', minWidth: 0 }}>
              <div style={{ fontWeight: 700, fontSize: 13, color: T.text, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{l.title}</div>
              <div style={{ fontSize: 11, color: T.textMuted }}>{[l.location, l.primaryGameType, l.price ? `${l.price} kr` : 'Gratis'].filter(Boolean).join(' · ')}</div>
            </div>
            <button type="button" disabled={busyId === l.id} onClick={() => void unpublish(l)} style={btn(T.amber)}>Avpublicera</button>
            <button type="button" disabled={busyId === l.id} onClick={() => remove(l)} style={btn('#E53935')}>Ta bort</button>
          </div>
        ))}
      </div>
    </div>
  );
}
